// extracted by mini-css-extract-plugin
export default {"pageHeader":"PageHeader_pageHeader__PKROz","line":"PageHeader_line__csMiM","closeContainer":"PageHeader_closeContainer__Usaxu","text":"PageHeader_text__NavM2"};